import React from "react";
import styled from "styled-components";
import { FontWeight, content } from "@glossy";

type IProps = React.LabelHTMLAttributes<HTMLLabelElement>;

const StyledLabel = styled.label`
  display: block;
  color: ${content};
  font-weight: ${FontWeight.Bold};
`;

const UiKitFormLabel = (props: IProps) => <StyledLabel {...props} />;

export default UiKitFormLabel;
